export const meKeys = {
  debugAccess: ['me', 'debug-access'] as const,
  me: ['me'] as const,
  passengers: ['me', 'passengers'] as const,
  profile: ['me', 'profile'] as const,
}
